import { useEffect, useState } from 'react';

const MIN_DURATION = 1800;
const EXIT_MS = 850;

export default function Preloader() {
  const reduced =
    typeof matchMedia !== 'undefined' &&
    matchMedia('(prefers-reduced-motion: reduce)').matches;

  const [phase, setPhase] = useState(reduced ? 'done' : 'loading');

  useEffect(() => {
    if (reduced) return undefined;

    document.body.style.overflow = 'hidden';
    const start = performance.now();
    let exitTimer;
    let removeTimer;

    const finish = () => {
      const wait = Math.max(0, MIN_DURATION - (performance.now() - start));
      exitTimer = setTimeout(() => {
        setPhase('exiting');
        removeTimer = setTimeout(() => setPhase('done'), EXIT_MS);
      }, wait);
    };

    if (document.readyState === 'complete') finish();
    else window.addEventListener('load', finish, { once: true });

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
      window.removeEventListener('load', finish);
      document.body.style.overflow = '';
    };
  }, [reduced]);

  useEffect(() => {
    if (phase === 'done') document.body.style.overflow = '';
  }, [phase]);

  if (phase === 'done') return null;

  return (
    <div className={`preloader ${phase === 'exiting' ? 'preloader--exit' : ''}`} aria-hidden="true">
      <div className="preloader__inner">
        <div className="preloader__mark">
          <span className="preloader__word">Napho</span>
          <span className="preloader__dot" />
        </div>
        <span className="preloader__bar"><span className="preloader__fill" /></span>
        <p className="preloader__tag">Clarity, as we build</p>
      </div>
    </div>
  );
}
